<template>
    <section style="min-width: 1400px;">
        <div class="footer_box">
            <ul class="footer_content">
                <li>
                    <div class="image_box">
                        <img src="../assets/footer/01.png" alt="海马行">
                    </div>
                    <p class="title">联系我们</p>
                    <div class="connect_us content">
                        <p>客服电话：4009030180</p>
                        <p>邮箱：hmjy@strongunion.com.cn</p>
                        <p>地址：北京市海淀区上地三街金隅嘉华大厦D座909</p>
                    </div>
                </li>
                <li>
                    <div class="image_box">
                        <img src="../assets/footer/02.png" alt="海马行">
                    </div>
                    <p class="title">申请试用</p>
                    <div class="content">
                        <p @click="applyUse">申请试用</p>
                    </div>
                </li>
                <li>
                    <div class="image_box">
                        <img src="../assets/footer/03.png" alt="海马行">
                    </div>
                    <p class="title">商户登陆</p>
                    <div class="content">
                        <a href="https://www.up-zy.com/marke/#/login" target="_blank">
                            <p>单站版</p>
                        </a>
                        <a href="https://www.up-zy.com/groupMarke/#/login" target="_blank">
                            <p>集团版</p>
                        </a>
                    </div>
                </li>
                <li>
                    <div class="image_box">
                        <img src="../assets/footer/04.png" alt="海马行">
                    </div>
                    <p class="title">APP下载</p>
                    <div class="content">
                        <p @click="download">APP下载</p>
                    </div>
                </li>
            </ul>
            <div></div>
        </div>
        <div class="copy">
            <div>
                <p>版权所有：北京思创银联科技股份有限公司<span style="padding-left:20px;"></span>京ICP备18049542号-1</p>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        applyUse(){
            this.$router.push({name: 'applyUse'})
        },
        download(){
            this.$router.push({name: 'APPdownload'})
        }
    },
}
</script>
<style scoped>
    .footer_box{
        background-color: #35363B;
        border-bottom: 1px solid #47484F;
    }
    .footer_content{
        width: 1200px;
        margin: 0 auto;
        color: white;
    }
    .footer_content li{
        display: inline-block;
        vertical-align: top;
        width: 300px;
        margin-top: 24px;
    }
    .footer_content .title{
        font-size: 18px;
        margin-bottom: 16px;
    }
    .footer_content .image_box{
        height: 44px;
        margin: 12px auto;
    }
    .connect_us{
        text-align: left;
    }
    .content a{
        color: #fff;
        cursor: pointer;
    }
    .content p{
        margin-bottom: 12px;
        cursor: pointer;
    }
    .copy{
        background-color: #35363B;
        color: white;
    }
    .copy div{
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
    }
</style>
